/** Page configuration modal: slider range and persisted `settings.maxWidthPercent`. */

export const CREATOR_PAGE_WIDTH_MIN = 60;
export const CREATOR_PAGE_WIDTH_DEFAULT = 60;
export const CREATOR_PAGE_WIDTH_MAX = 100;

/** Link-in-bio / standalone / creator-page shell — 60% slider maps here (45rem @ 16px). */
export const SHELL_BASE_WIDTH_REM = 45;
export const CREATOR_PAGE_BASE_WIDTH_REM = SHELL_BASE_WIDTH_REM;

const REM_PX = 16;

export function coerceCreatorPageWidthPercent(value: unknown): number {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return CREATOR_PAGE_WIDTH_DEFAULT;
  return Math.min(
    CREATOR_PAGE_WIDTH_MAX,
    Math.max(CREATOR_PAGE_WIDTH_MIN, Math.round(n))
  );
}

/** 60% → 45rem; 75% → 56.25rem; 90% → 67.5rem (linear from default). */
export function creatorPageWidthPercentToRem(pct: number): number {
  const p = coerceCreatorPageWidthPercent(pct);
  return (SHELL_BASE_WIDTH_REM * p) / CREATOR_PAGE_WIDTH_DEFAULT;
}

export function getCreatorPageMaxWidthCss(pct: number): string {
  return `min(100%, ${creatorPageWidthPercentToRem(pct)}rem)`;
}

export function getCreatorPageShellMaxPx(
  screenWidth: number,
  maxWidthPercent: number
): number {
  const remCap = creatorPageWidthPercentToRem(maxWidthPercent) * REM_PX;
  return Math.min(screenWidth, remCap);
}

/** Usable inner width for grids inside `.uptodate-wrapper` on creator pages. */
export function getCreatorPageContentWidthPx(
  screenWidth: number,
  maxWidthPercent: number
): number {
  const shell = getCreatorPageShellMaxPx(screenWidth, maxWidthPercent);
  const horizontalPadding = screenWidth < 890 ? 0 : 60;
  return Math.max(0, shell - horizontalPadding);
}

export function isCreatorPageNarrowWidth(maxWidthPercent: number): boolean {
  return (
    coerceCreatorPageWidthPercent(maxWidthPercent) <= CREATOR_PAGE_WIDTH_DEFAULT
  );
}

export function getNarrowShellMaxPx(screenWidth: number): number {
  return Math.min(screenWidth, SHELL_BASE_WIDTH_REM * REM_PX);
}

/** Inner content width for link-in-bio / standalone ~45rem shells. */
export function getNarrowShellContentWidthPx(screenWidth: number): number {
  const shell = getNarrowShellMaxPx(screenWidth);
  const horizontalPadding = screenWidth < 890 ? 0 : 60;
  return Math.max(0, shell - horizontalPadding);
}
